import { useState } from "react";
import { useSelector } from "react-redux";
import FullCalendarTimeslot from "../common/fullcalendarTimeslot";
import PopUpViewPrenotationByTimeslot from "../popUpViewPrenotationByTimeslot";
import _ from "lodash";
import moment from "moment";
import { hasModules } from "../../utils/helpers";

const PrenotationListCalendar = () => {
  const [showPopUpViewPrenotationByTimeslot, setShowPopUpViewPrenotationByTimeslot] = useState(false);
  const [selectedBookingId, setSelectedBookingId] = useState("");
  const [selectedTimeslot, setSelectedTimeslot] = useState("");
  const [selectedDay, setSelectedDay] = useState("");

  const { eventId, user } = useSelector((store: any) => store.login);
  const isDoctor = hasModules(user,'FEDERFARMA_DOCTOR') ? true : false

  let eventsSourceUrl = '';
  if(isDoctor){
    eventsSourceUrl = `t4event/api/v01/federfarma/doctor/fullcalendar/attendances`;
  } else {
   eventsSourceUrl = `t4event/api/v01/event/${eventId}/fullcalendar/attendances`;
  }

  // timeslot category selected in filter box
  const { search } = useSelector((store: any) => store.prenotation);
  const categoryIds = search.timeslotCategory ? [search.timeslotCategory] : [];

  const ClickFullCalendar = (arg: any) => {
    let selectTimeslotId = arg.event.extendedProps.timeslotId
    if(isDoctor){
    selectTimeslotId = `${moment(arg.event.start).format('[T]HH:mm:ss.SSS[Z]')}${moment(arg.event.end).format('[T]HH:mm:ss.SSS[Z]')}`
    }
    setSelectedBookingId(arg.event.extendedProps.bookingId);
    setSelectedTimeslot(selectTimeslotId);
    setSelectedDay(moment(arg.event.start).format('YYYY-MM-DD'));

    setShowPopUpViewPrenotationByTimeslot(true)
  }

  return (
    <>
      <div className="SectionPrenotation">
        <FullCalendarTimeslot
          typeCalendar="attendancesList"
          eventClick={ClickFullCalendar}
          eventsSourceUrl={eventsSourceUrl}
          ids={categoryIds}
          searchText={search.searchInput}
          idsParamKey={isDoctor ? "categorySlug" : "categoryIds[]"}
        />
      </div>

      {showPopUpViewPrenotationByTimeslot && <PopUpViewPrenotationByTimeslot
        selectedDay={selectedDay}
        selectedTimeslotId={selectedTimeslot}
        selectedBookingId={selectedBookingId}
        closePopUp={() => setShowPopUpViewPrenotationByTimeslot(false)}
      />}
    </>
  )
}

export default PrenotationListCalendar;